var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerIconProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-progress"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.38472 17C7.70295 16.8425 7.04818 16.582 6.44217 16.2272M11.5182 3C13.0755 3.36214 14.4659 4.25189 15.4618 5.52358C16.4577 6.79527 17 8.37354 17 10C17 11.6265 16.4577 13.2047 15.4618 14.4764C14.4659 15.7481 13.0755 16.6379 11.5182 17M4.13855 14.0617C3.71128 13.4297 3.38676 12.7316 3.17746 11.9945M3 8.80359C3.12533 8.04593 3.36658 7.32814 3.70496 6.67017L3.83733 6.42693M5.9618 4.08146C6.69468 3.56777 7.51687 3.20075 8.3845 3",
    stroke: "#FFA800",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconProgress);
export default __webpack_public_path__ + "static/media/tabler-icon-progress.b00bf35e25dcefeac409e63077e9bb64.svg";
export { ForwardRef as ReactComponent };